import { define } from '../../define.js';
import { Tag } from './tag.js';
export * from './tag.js';
define('tag', Tag);
